import {createAction} from 'Shared/utilities/actionCreator';

export enum FeatureConstants {
  BR_FOOTER = 'BR_Footer',
  TEN_99_PRO = 'Tax1099Form',
  BR_SISENSE = 'BR_Sisense',
  BR_WHATFIX = 'BR_WhatFix',
  BR_A360_EnrollmentUpload = 'BR_A360_EnrollmentUpload',
  BR_QUOTING_TOOL = 'BR_QuotingTool',
  enable_portals_virus_scan = 'enable_portals_virus_scan',
  BR_QUOTING_TOOL_GPLU = 'BR_QuotingTool_GPLU',
  BR_QUOTING_TOOL_EIS_VALIDATION = 'BR_QuotingTool_EIS_Validation',
  ENABLE_TAX_PORT_YEAR_FILTER = 'ENABLE_TAX_PORT_YEAR_FILTER',
  SIC_FileNet_Connectivity = 'SIC_FileNet_Connectivity',
}

export enum FeatureToggleActionType {
  GET_OR_CREATE_FEATURE = 'featureToggle/GET_OR_CREATE_FEATURE',
  CHANGE_FEATURE_IS_ACTIVE = 'featureToggle/CHANGE_FEATURE_IS_ACTIVE',
  GET_LANDING_PAGE_FOOTER_FEATURE = 'featureToggle/GET_LANDING_PAGE_FOOTER_FEATURE',
  GET_SISENSE_FEATURE = 'featureToggle/GET_SISENSE_FEATURE',
}

type FeatureState = {
  BR_Footer: boolean;
  Tax1099Form: boolean;
  BR_Sisense: boolean;
  BR_WhatFix: boolean;
  BR_QuotingTool: boolean;
  BR_A360_EnrollmentUpload: boolean;
  enable_portals_virus_scan: boolean;
  BR_QuotingTool_GPLU: boolean;
  BR_QuotingTool_EIS_Validation: boolean;
  ENABLE_TAX_PORT_YEAR_FILTER: boolean;
  SIC_FileNet_Connectivity: boolean;
  resolvedFeatures?: {[key: string]: boolean};
};

export const DEFAULT_STATE: FeatureState = {
  BR_Footer: false,
  Tax1099Form: false,
  BR_Sisense: false,
  BR_WhatFix: false,
  BR_A360_EnrollmentUpload: false,
  BR_QuotingTool: false,
  enable_portals_virus_scan: false,
  BR_QuotingTool_GPLU: false,
  BR_QuotingTool_EIS_Validation: false,
  ENABLE_TAX_PORT_YEAR_FILTER: false,
  SIC_FileNet_Connectivity: false,
  resolvedFeatures: {},
};

export const getOrCreateFeatureFlag = (featureName: FeatureConstants, defaultActive?: boolean) =>
  createAction(FeatureToggleActionType.GET_OR_CREATE_FEATURE, {featureName, defaultActive});

export const changeFeatureIsActive = (featureName: FeatureConstants, isActive: boolean) =>
  createAction(FeatureToggleActionType.CHANGE_FEATURE_IS_ACTIVE, {featureName, isActive});

export const getLandingPageFooterFeatureFlag = () =>
  createAction(FeatureToggleActionType.GET_LANDING_PAGE_FOOTER_FEATURE);

type FeatureAction =
  | ReturnType<typeof getOrCreateFeatureFlag>
  | ReturnType<typeof changeFeatureIsActive>
  | ReturnType<typeof getLandingPageFooterFeatureFlag>;

export default (state: FeatureState = DEFAULT_STATE, action: FeatureAction): FeatureState => {
  if (action.type === FeatureToggleActionType.CHANGE_FEATURE_IS_ACTIVE) {
    return {
      ...state,
      [action.payload.featureName]: action.payload.isActive,
      resolvedFeatures: {
        ...state.resolvedFeatures,
        [action.payload.featureName]: true,
      },
    };
  }
  return state;
};
